/**
 * Created by lari on 27/04/2017.
 */
(function () {
  'use strict';
  angular.module('vcexam')
    .component('examtagstring', {
      restrict: 'E',
      bindings: {
        valuearray: '='
      },
      template: `<span ng-repeat="val in vm.valuearray">{{val.name}}{{$last ? '' : ', '}}</span>`,
      controllerAs: 'vm',
      controller: ['$log',
        function ($log) {
          var vm = this;
        }] // controller
    }); // component

// klammerfriedhof
}());